import React from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Image,
  Spacer,
  Text,
  useColorModeValue
} from '@chakra-ui/react'
// Removed icon import in favor of text symbol
import { StockData } from '../types'
import { formatPercent, formatPrice } from '../utils'

interface StockHeaderProps {
  borderColor: string
  cardBg: string
  data: StockData
  isRefreshing: boolean
  onRefresh: () => void
}

const StockHeader: React.FC<StockHeaderProps> = ({
  borderColor,
  cardBg,
  data,
  isRefreshing,
  onRefresh
}) => {
  const positiveColor = useColorModeValue('green.500', 'green.300')
  const negativeColor = useColorModeValue('red.500', 'red.300')
  const changeColor = data.change >= 0 ? positiveColor : negativeColor
  
  return (
    <Box
      bg={cardBg}
      borderColor={borderColor}
      borderRadius="lg"
      borderWidth="1px"
      p={4}
      shadow="sm"
    >
      <Flex align="center" direction={{ base: 'column', md: 'row' }} mb={4}>
        <HStack spacing={4}>
          <Image
            alt={`${data.symbol} logo`}
            borderRadius="full"
            boxSize="40px"
            fallbackSrc="/assets/images/mstr-logo.svg"
            src={data.logo}
          />
          <Box>
            <Heading as="h1" size="lg">{data.companyName}</Heading>
            <Text color="gray.500" fontSize="sm">{data.symbol} • {data.sector}</Text>
          </Box>
        </HStack>
        
        <Spacer />
        
        <HStack mt={{ base: 4, md: 0 }} spacing={4}>
          <Box textAlign={{ base: 'center', md: 'right' }}>
            <Heading as="h2" size="lg">{formatPrice(data.price)}</Heading>
            <Text color={changeColor} fontWeight="bold">
              {formatPrice(data.change)} ({formatPercent(data.changePercent)})
            </Text>
          </Box>
          
          <Button
            colorScheme="orange"
            isLoading={isRefreshing}
            leftIcon={<Text>↻</Text>}
            onClick={onRefresh}
            size="sm"
            variant="outline"
          >
            Refresh
          </Button>
        </HStack>
      </Flex>
      
      <Text color="gray.600" fontSize="sm" mt={2}>
        {data.description}
      </Text>
    </Box>
  )
}

export default StockHeader
